import {
  Backend,
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import { PaymentShareMembersSpentAmountCollection } from './payment-share-members-spent-amount.types';

export function paymentShareMembersSpentAmountBackend(): Backend<
  PaymentShareMembersSpentAmountCollection
> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query) => ({
      endpoint: 'users/0.1/payment_sharing/members',
      isGaf: false,
      params: {
        payment_share_member_ids: ids,
        member_entity_id: getQueryParamValue(query, 'entityId')[0],
        member_entity_type: getQueryParamValue(query, 'entityType')[0],
        current_spent_amount: true,
      },
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
